import { useRef, useState } from "react";
import { formatMoney, onfocus, Loading, defaulUrl, decryptData } from "../components/const";
import Swal from "sweetalert2";

const ModalEcriture = ({ patenaire }) => {
    const [paye, setPaye] = useState(0)
    const [isLoading, setIsLoading] = useState(false)
    const [errors, setErrors] = useState(null)
    const [type, setType] = useState('');
    const [devise, setDevise] = useState('')
    const [valeur_du_jour, setValeur] = useState(1)
    const [commentaire, setCommentaire] = useState('')
    const ref = useRef()

    const handlePayer = (e) => {
        e.preventDefault();
        setIsLoading(true);
        let formdata = new FormData();
        formdata.append('type', type)
        formdata.append('montant', paye)
        formdata.append('id_confier', patenaire.id)
        formdata.append('valeur_du_jour', valeur_du_jour)
        formdata.append('commentaire', commentaire)
        formdata.append('devise', devise)

        let status = 0;
        fetch(`${defaulUrl}confier/ecriture`, {
            method: "POST",
            headers: {
                Accept: 'application/json',
                ContentType: 'application/json',
                Authorization: `Bearer ${decryptData('ACCESS_TOKEN')}`
            },

            body: formdata
        }).then((response) => {
            status = response.status;
            return response.json()
        }).then(data => {
            setIsLoading(false);

            if (status === 200) {
                Swal.fire({
                    title: 'Succès',
                    text: data.message,
                    icon: 'success'
                }).then(() => {

                    ref.current.click();
                })
            } else {
                setErrors(data.errors);
            }
        })
        setErrors(null);

    }
    return (

        <div className="modal fade " id="modal-ecriture" aria-labelledby="exampleModalLabel" aria-hidden="true">
            <div className="modal-dialog">
                <div className="modal-content">
                    <div className="modal-header bg-secondary-subtle">
                        <h1 className="modal-title fs-5" id="exampleModalLabel">Nouvelle Operation</h1>
                        <button type="button " className="btn-close btn-danger" data-bs-dismiss="modal" aria-label="Close"></button>
                    </div>
                    <form className="px-3" onSubmit={handlePayer}>
                        <div className="modal-body position-relative">

                            <div className="form-group">
                                <label htmlFor="" className="fs-6">Partenaire</label>
                                <input type="text" className="form-control" disabled defaultValue={patenaire?.nom_complet?.toUpperCase()} />
                            </div>
                            <div className="form-group mt-1">
                                <label htmlFor="" className="fs-6">Type operation</label>
                                <div className="row my-1">
                                    <div className="col-4">
                                        <input type="radio" name="operation" className="form-input-radio" id="depot" onChange={(e) => setType('Depot')} />
                                        <label htmlFor="depot" className="ms-1">Depot</label>
                                    </div>
                                    <div className="col-4 ">
                                        <input type="radio" name="operation" className="form-input-radio" id="retrait" onChange={(e) => setType('Retrait')} />
                                        <label htmlFor="retrait" className="ms-1 w-auto">Retrait</label>
                                    </div>
                                </div>
                                {errors?.type && <span><small className="text-danger p-1">{errors?.type}</small></span>}
                            </div>
                            <div className="form-group my-1">
                                <label htmlFor="">Devise</label>
                                <select name="devise" id="devise" className="form-select" onChange={(e) => setDevise(e.target.value)}>
                                    <option value="">Votre choix</option>
                                    <option value="GNF">GNF</option>
                                    <option value="$">Dollars</option>
                                    <option value="€">Euro</option>
                                </select>
                                {errors?.devise && <span className="text-danger p-1 small">{errors?.devise}</span>}
                            </div>

                            <div className="form-group my-1" onChange={(e) => setValeur(e.target.value)} hidden >
                                <label htmlFor="">Valeur du jour</label>
                                <input type="number" className="form-control" name="valeur_du_jour" defaultValue={1} />
                            </div>
                            <div className="form-group">
                                <label htmlFor="" className="fs-5">Montant</label>
                                <div className="input-group mb-3">
                                    <input type="text" className="form-control" defaultValue={paye}
                                        onChange={(e) => {
                                            setPaye(e.target.value.replace(/\s/g, ""));
                                        }}
                                        onBlur={(e) => formatMoney(e)}
                                        onFocus={(e) => onfocus(e)} />
                                    {/* <span className="input-group-text" id="basic-addon2">GNF</span> */}
                                </div>
                                {errors?.montant && <span className="text-danger p-1 small">{errors?.montant}</span>}
                            </div>
                            <div className="form-group my-1">
                                <textarea name="description" id="description" className="form-control" placeholder="Desctipton" defaultValue={commentaire} onChange={(e) => setCommentaire(e.target.value)} />
                            </div>
                            {isLoading && <Loading />}
                        </div>
                        <div className="modal-footer">
                            <div type="button" className="btn btn-danger" data-bs-dismiss="modal" ref={ref}>Annuler</div>
                            <button type="submit" className="btn btn-success" disabled={isLoading}>Eregistrer</button>
                        </div>
                    </form>
                </div>

            </div>
        </div>
    );
}

export default ModalEcriture;